import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent, Divider, Typography, Button, Box } from '@mui/material'

import { BootstrapDialogTitle } from '../dialog-modal'

const ConfirmDialog = ({ open, title, question, description, confirmLabel, cancelLabel, onSubmit, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="confirm-dialog-title"
    sx={{ '& .MuiDialog-paper': { width: 500, height: 356 } }}
  >
    <BootstrapDialogTitle id="confirm-dialog-title" onClose={onClose}>
      {title}
    </BootstrapDialogTitle>

    <Divider />

    <DialogContent sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box px={2} display="flex" justifyContent="center" alignItems="center" flex={1}>
        <Typography id="modal-modal-question" variant="h6" align="center">
          {question}
        </Typography>
      </Box>

      <Box px={2} display="flex" justifyContent="center" alignItems="center" flex={1}>
        <Typography variant="body1" align="center">
          {description}
        </Typography>
      </Box>
    </DialogContent>

    <Box py={1} display="flex" flexDirection="column" sx={{ width: '50%', margin: 'auto' }}>
      <Button color="error" size="large" variant="contained" mt={2} onClick={onSubmit}>
        {confirmLabel}
      </Button>

      <Button color="error" size="large" autoFocus onClick={onClose}>
        {cancelLabel}
      </Button>
    </Box>
  </Dialog>
)

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

ConfirmDialog.defaultProps = {
  confirmLabel: 'Yes',
  cancelLabel: 'Stay here',
}

export default ConfirmDialog
